<script setup>
import { useAuthStore } from '@/stores/auth';
import { useGamesStore } from '@/stores/games';
import { normalizeLang } from '@/helpers';
import { storeToRefs } from 'pinia';
import { onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import FunPlayModal from './Partials/FunPlayModal.vue';
const assetsUrl = import.meta.env.VITE_ASSETS_URL
const resources = ref([])
const meta = ref({})
const search = ref('')

const auth = useAuthStore()
const games = useGamesStore()
const route = useRoute()
const router = useRouter()

const { getCredits, getCurrency, getUser, isAuth } = storeToRefs(auth)
const { getGame } = storeToRefs(games)

const selectedGame = ref(null)
const modalRef = ref(null)
const lang = ref(normalizeLang(localStorage.getItem('lang')))

const openGame = (game) => {
  if (isAuth.value) {
    if (game.has_demo === 'Y' && getUser.value?.c_p_demo) {
      selectedGame.value = game
      modalRef.value.openModal()
    } else {
      launchGame(game, false)
    }
  } else {
    router.push({ name: 'login' })
  }
}

const launchGame = async (game, isDemo) => {
  try {
    const res = await games.openGame(game._id, {
      device: 'M',
      currency_id: getCredits.value[0].cuid._id,
      currency_name: getCurrency.value(getCredits.value[0].cuid._id).cod,
      homeURL: import.meta.env.VITE_APP_URL,
      demo: isDemo,
      lang: lang.value
    });

    if (res.data?.nt === true) {
      window.open(res.data.data, '_blank');
      return;
    }

    if (res.data?.nt === false) {
      games.setGameUrl(res.data.data);
      router.push('/casino/game');
    }
  } catch (error) {
    console.error(error);
  }
};


const handlePlay = ({ demo }) => {
  launchGame(selectedGame.value, demo)
}

const loadGames = async (page = 1, searchTerm = '') => {
  const res = await games.fetchGamesByProvider(route.params.id, page, searchTerm)
  if (res.data.ok) {
    if (page === 1) {
      resources.value = res.data.data.games
    } else {
      resources.value = [...resources.value, ...res.data.data.games]
    }
    meta.value = res.data.data.meta
  }
}

const moreGames = async () => {
  meta.value.page++
  await loadGames(meta.value.page, search.value.length >= 3 ? search.value : '')
}

// watch(getGame, () => {
//   router.push('/casino/game')
// })

watch(search, (newVal) => {
  if (newVal.length >= 3) {
    loadGames(1, newVal)
  } else if (newVal.length === 0) {
    loadGames()
  }
})

onMounted(async () => {
  await loadGames()
})
</script>

<template>
  <div>
    <div class="flex items-center justify-between">
      <h3 class="text-gray-300 font-bold text-xl py-2 px-4">{{$t('app.37')}}</h3>
      <div class="SearchInput">
        <div class="SearchInput_Icon" />
        <input
          class="SearchInput_Field"
          :placeholder="$t('app.8')"
          type="search"
          v-model="search"
        />
      </div>
    </div>

    <div class="px-3 grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-4 mt-6 space-x-1">
      <template v-for="game in resources" :key="game._id">
        <div class="cursor-pointer" @click="openGame(game)">
          <img :src="game.img ? `${assetsUrl}/c/g/${game.img}` : game.extimg" class="w-full h-full rounded-xl" alt="">
        </div>
      </template>
    </div>

    <div class="mt-4 flex justify-center" v-if="meta.hasNextPage">
      <button 
        class="text-sm text-white font-medium shadow-md bg-[var(--color-primary1)] rounded-md py-2 px-4" 
        @click="moreGames"
      >
        {{ $t('app.38') }}
      </button>
    </div>

    <FunPlayModal ref="modalRef" :value="selectedGame" @play="handlePlay" />
  </div>
</template>

<style scoped>
.SearchInput {
    background-color: hsla(0,0%,100%,.1);
    border-radius: 50px;
    display: flex;
    @apply mx-3 mt-2 px-3;
}

.SearchInput_Icon {
    mask-image: url("/search.svg");
    mask-size: 18px 18px;
    mask-repeat: no-repeat;
    mask-position: center;
    min-width: 18px;
    background-color: #fff;
    z-index: 20;
    display: flex;
    flex-direction: column
}

.SearchInput_Field {
    @apply flex-1 text-sm !bg-transparent placeholder:text-white font-bold text-white py-2.5 border-0;
    @apply focus:ring-0;
}
</style>
